import React from "react";
import { useState } from "react";
import validateForm from "../../../components/validateForm";
import './newsletter.css'
const Newsletter = () => {
  const [formValue, setFormValue] = useState({ email: "" });
  const [submit, setSubmit] = useState(false);
  const [formError, setFormError] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validate(formValue);
    setFormError(errors);
  
    if (Object.keys(errors).length === 0) {
      try {
        const response = await fetch("/.netlify/functions/brevoContact", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: formValue.email,
            listIds: [3],
          }),
        });
  
        if (response.ok) setSubmit(true);
      } catch (error) {
        console.error("Submission failed:", error);
      }
    }
  }
  const handleValidation = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  }
  const validate = validateForm("newsletter");
  return (

    <section className="homepage__newsletter">
        <h3 className="newsletter__title">
          Abonniere unseren Newsletter, um Updates zur Speisekarte zu erhalten und tolle Geschenke zu genießen!
        </h3>
      {submit && Object.keys(formError).length === 0 ?
        <p className="newsletter__success">Du hast unseren Newsletter erfolgreich abonniert!</p> :
          <form onSubmit={handleSubmit} className="newsletter__form">
            <div className="webflow-style-input">
              <input name="email" onChange={handleValidation} value={formValue.email} placeholder="Wie lautet deine E-Mail?" />
            </div>
            <span className="newsletter__error">{formError.email}</span>
            <button type="submit" className="active-button-style">
              Jetzt abonnieren
            </button>
          </form>
      }
    </section>
  );
}

export default Newsletter;
